import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { AppHeader } from '../components/index';
import { useSelector, useDispatch } from 'react-redux';
import { userManager } from '../authentication';
import { Layout } from 'antd';
import { getkycData } from 'src/reducers/configReduser';
import { getAdminDetails, getCustomerToken,getLogoUrls } from 'src/reducers/authReducer';

import HeaderComponent from 'src/components/header'

const { Sider } = Layout;

const DefaultLayout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const User = useSelector((state) => state.oidc.user);
  const kycData = useSelector((state) => state.configData?.kycData);
  const menuData = useSelector((state) => state.commonData?.cardspermissionsconfig);
  const loader = useSelector((state) => state.commonData?.mainmenuloader);

  const [adminFetched, setAdminFetched] = useState(false);
  useEffect(() => {
    if (!User || User?.expires_at) {
      if (!window.location.pathname.includes('callback')) {
        userManager.clearStaleState().then(() => {
          userManager.signinRedirect();
        });
      }
    }
  }, []);
  useEffect(() => {
    if (User?.currentUser?.tenantId && !adminFetched) {
      dispatch(getAdminDetails());
      dispatch(getCustomerToken())
      dispatch(getLogoUrls())
      setAdminFetched(true);
    }
  }, [User, dispatch, adminFetched]);
  useEffect(() => {
    if (adminFetched && User?.currentUser?.tenantId) {
      dispatch(getkycData(User.currentUser.tenantId));
    }
  }, [adminFetched, User, dispatch]);
  useEffect(() => {
    if (kycData) {
      if (!kycData?.isKybState) {
        navigate("/sumsub");
      } else if (menuData?.length == 0 && loader === false) {
        navigate("/accessdenied");
      } else {
        navigate(menuData[0]?.path);
      }
    }
  }, [kycData, navigate, menuData]);

  if ((!User || User?.expires_at) && !window.location.pathname.includes('callback') && loader === true) {
    return <div className="layout sticky-header overflow-auto"><div className="loader">Loading .....</div></div>;
  }

  return (
    <Layout className='layout-section'>


      <Sider
        breakpoint="lg"
        collapsedWidth="0"
        className='sidebar'
      >
        {kycData && kycData?.isKybState && <div className="layout sticky-header overflow-auto">
          <AppHeader />
        </div>
        }
      </Sider>
      <Layout>
        {window.location.pathname.includes("/accessdenied") && <HeaderComponent />}
        <div className='px-4 max-lg:mt-10'>
          <Outlet />
        </div>
      </Layout>
    </Layout>
  );
};

export default DefaultLayout;
